import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import HomepageTemplate from 'gatsby-theme-carbon/src/templates/Homepage';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ArticleCard = makeShortcode("ArticleCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = HomepageTemplate;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Getting Started`}</h2>
    <Row mdxType="Row">
      <Column colLg={4} colMd={4} noGutterMdLeft mdxType="Column">
        <ArticleCard color="dark" subTitle="Overview & Agenda" title="Are you looking for details about the training?" href="/overview/" actionIcon="arrowRight" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARASEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAMEAgX/xAAVAQEBAAAAAAAAAAAAAAAAAAABAP/aAAwDAQACEAMQAAAB7CdxDeLI/8QAGhAAAgIDAAAAAAAAAAAAAAAAAQIAAxMhIv/aAAgBAQABBQIRrOlOQGKJVpP/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAcEAACAQUBAAAAAAAAAAAAAAARAAFBAhASITL/2gAIAQEABj8CYHmrt2MXQaoAf//EABsQAAICAwEAAAAAAAAAAAAAAAEAESExQWFR/9oACAEBAAE/IeiI8Sg2k4W1KHrgzXjCrlTqZf/aAAwDAQACAAMAAAAQM/8A/8QAFhEBAQEAAAAAAAAAAAAAAAAAARAR/9oACAEDAQE/EA1n/8QAFhEBAQEAAAAAAAAAAAAAAAAAARAR/9oACAECAQE/EFyf/8QAHBABAAICAwEAAAAAAAAAAAAAAREAITFBgVHB/9oACAEBAAE/EDIQAzLmruJbYozJzqkYMwGKntlpHdbIOYdxE77oy2T9E3//2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "workshop",
              "title": "workshop",
              "src": "/tech-academy-apac/static/ecb6b05eb00068cb7973cbc28bee2d41/2e753/workshop.jpg",
              "srcSet": ["/tech-academy-apac/static/ecb6b05eb00068cb7973cbc28bee2d41/69549/workshop.jpg 288w", "/tech-academy-apac/static/ecb6b05eb00068cb7973cbc28bee2d41/473e3/workshop.jpg 576w", "/tech-academy-apac/static/ecb6b05eb00068cb7973cbc28bee2d41/2e753/workshop.jpg 1152w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
      <Column colLg={4} colMd={4} noGutterMdLeft mdxType="Column">
        <ArticleCard color="white" subTitle="Resources" title="Here you have all the assets to complete your training" href="/resources/" actionIcon="arrowRight" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARASEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAwABBf/EABUBAQEAAAAAAAAAAAAAAAAAAAID/9oADAMBAAIQAxAAAAHFKCuY2pf/xAAZEAADAQEBAAAAAAAAAAAAAAABAgARAzH/2gAIAQEAAQUCQXRcEGyLsY+//8QAFhEAAwAAAAAAAAAAAAAAAAAAEBEh/9oACAEDAQE/AVR//8QAFhEBAQEAAAAAAAAAAAAAAAAAEQEQ/9oACAECAQE/AUhn/8QAGBAAAwEBAAAAAAAAAAAAAAAAIQAQAQL/2gAIAQEABj8CTAnrZ//EABgQAQADAQAAAAAAAAAAAAAAAAEAITER/9oACAEBAAE/IQdmASqqJxjEaIzXg6djj//aAAwDAQACAAMAAAAQb+//xAAWEQEBAQAAAAAAAAAAAAAAAAABEQD/2gAIAQMBAT8QW1cWb//EABcRAQEBAQAAAAAAAAAAAAAAAAEAESH/2gAIAQIBAT8QDwSG3//EABoQAQEBAQADAAAAAAAAAAAAAAERAEExUWH/2gAIAQEAAT8Qv2/APOn9Q3jWDMk1BysllHE9ai3/2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "multi cloud",
              "title": "multi cloud",
              "src": "/tech-academy-apac/static/d2c987e9c8bff0ea05aa9e264b97e4ad/2e753/multi-cloud.jpg",
              "srcSet": ["/tech-academy-apac/static/d2c987e9c8bff0ea05aa9e264b97e4ad/69549/multi-cloud.jpg 288w", "/tech-academy-apac/static/d2c987e9c8bff0ea05aa9e264b97e4ad/473e3/multi-cloud.jpg 576w", "/tech-academy-apac/static/d2c987e9c8bff0ea05aa9e264b97e4ad/2e753/multi-cloud.jpg 1152w", "/tech-academy-apac/static/d2c987e9c8bff0ea05aa9e264b97e4ad/74f4b/multi-cloud.jpg 1728w", "/tech-academy-apac/static/d2c987e9c8bff0ea05aa9e264b97e4ad/de5bb/multi-cloud.jpg 2304w", "/tech-academy-apac/static/d2c987e9c8bff0ea05aa9e264b97e4ad/9dba4/multi-cloud.jpg 2800w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
      <Column colLg={4} colMd={4} noGutterMdLeft mdxType="Column">
        <ArticleCard color="dark" subTitle="Team Environments" title="Are you looking for your team environment for GitOps session?" href="/environments/" actionIcon="arrowRight" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARASEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIDAQT/xAAWAQEBAQAAAAAAAAAAAAAAAAACAQP/2gAMAwEAAhADEAAAAcldRoxzin//xAAaEAABBQEAAAAAAAAAAAAAAAAAASECAxIz/9oACAEBAAEFAqmjlqeaaFSQ5//EABYRAQEBAAAAAAAAAAAAAAAAAAEAEf/aAAgBAwEBPwEMLL//xAAWEQEBAQAAAAAAAAAAAAAAAAABEEH/2gAIAQIBAT8B1Z//xAAYEAEBAAMAAAAAAAAAAAAAAAAAQQERMf/aAAgBAQAGPwLLTiIj/8QAHRAAAgIBBQAAAAAAAAAAAAAAAQARIRAxQVFxgf/aAAgBAQABPyHYbZESGk+2gQHNkArAO6//2gAMAwEAAgADAAAAECzP/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAERMf/aAAgBAwEBPxCQrgx//8QAGBEAAgMAAAAAAAAAAAAAAAAAAAERIVH/2gAIAQIBAT8Qd7ST/8QAHBAAAgICAwAAAAAAAAAAAAAAAREhADFRYXHw/9oACAEBAAE/EAALZEQEvCqIMGWhZcV6SIkmJoqB7k2UY6TpU4Onf//Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "resources",
              "title": "resources",
              "src": "/tech-academy-apac/static/08a3e7bdcbd4c4771ff4207588cc1709/2e753/resources.jpg",
              "srcSet": ["/tech-academy-apac/static/08a3e7bdcbd4c4771ff4207588cc1709/69549/resources.jpg 288w", "/tech-academy-apac/static/08a3e7bdcbd4c4771ff4207588cc1709/473e3/resources.jpg 576w", "/tech-academy-apac/static/08a3e7bdcbd4c4771ff4207588cc1709/2e753/resources.jpg 1152w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      